<div class="image-404">
    <img src="../../../assets/Images/page-404.png" alt="page not found" />
</div>
